// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionAsSeenOn_title__1YRoN","sites":"SectionAsSeenOn_sites__3xNgy","site":"SectionAsSeenOn_site__P0Vgy"};